module.exports = __webpack_public_path__ + "assets/img/922190.a6c421be.jpg";